/**
 * 数值比重字段（ 例如：待发货量/总数量 ） 对应的表格单元格
 */
import Proportion from './proportion.vue';
export default Proportion;
